/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class LanguagetoolService extends __BaseService {
  static readonly languagetoolCheckCreatePath = '/languagetool/check';
  static readonly languagetoolInlineV2CheckCreatePath = '/languagetool/inline/v2/check';
  static readonly languagetoolLanguagesListPath = '/languagetool/languages';
  static readonly languagetoolStatusListPath = '/languagetool/status';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Proxy for OmniPoly: accepts JSON {text, language}, forwards to LanguageTool, returns full response.
   */
  languagetoolCheckCreateResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/languagetool/check`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Proxy for OmniPoly: accepts JSON {text, language}, forwards to LanguageTool, returns full response.
   */
  languagetoolCheckCreate(): __Observable<null> {
    return this.languagetoolCheckCreateResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Proxy for quill-languagetool: accepts form-urlencoded {text, language, token},
   * forwards to LanguageTool, returns full response. Token is passed in body
   * since quill-languagetool cannot set custom headers.
   */
  languagetoolInlineV2CheckCreateResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/languagetool/inline/v2/check`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Proxy for quill-languagetool: accepts form-urlencoded {text, language, token},
   * forwards to LanguageTool, returns full response. Token is passed in body
   * since quill-languagetool cannot set custom headers.
   */
  languagetoolInlineV2CheckCreate(): __Observable<null> {
    return this.languagetoolInlineV2CheckCreateResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Proxy for OmniPoly: returns available languages from LanguageTool.
   */
  languagetoolLanguagesListResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/languagetool/languages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Proxy for OmniPoly: returns available languages from LanguageTool.
   */
  languagetoolLanguagesList(): __Observable<null> {
    return this.languagetoolLanguagesListResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Returns status for OmniPoly frontend — indicates LanguageTool is available.
   */
  languagetoolStatusListResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/languagetool/status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Returns status for OmniPoly frontend — indicates LanguageTool is available.
   */
  languagetoolStatusList(): __Observable<null> {
    return this.languagetoolStatusListResponse().pipe(
      __map(_r => _r.body as null)
    );
  }
}

module LanguagetoolService {
}

export { LanguagetoolService }
